module.exports = __webpack_public_path__ + "static/media/angela_merkel.921156a4.jpg";